import apiClient from './apiClient';


export const sentOtp = async (email, purpose) => {
  const res = await apiClient.post('/Users/SentOtp', {
    email: email,
    purpose: purpose
  });

  return res.data; // ✅ IMPORTANT
};

export const verifyOtp = async (email, otp) => {
  const res = await apiClient.post('/Users/VerifiedOtp', { 
    email : email, 
    otp : otp 
  });
  return res.data; // ✅ IMPORTANT
};

export const forgotPassword = async (email, newPassword, confirmpassword) => {
  const res = await apiClient.post('/Users/ForgetPassWord', { 
    email : email, 
    newPassword : newPassword, 
    confirmpassword : confirmpassword 
  });
  return res.data; // ✅ IMPORTANT
};
